import { CommonModule } from '@angular/common';
import { Component, Input, Output, EventEmitter } from '@angular/core';
import { FileHandlerComponent } from 'src/app/components/file-handler/file-handler.component';
import { TitleIconComponent } from 'src/app/components/icon/title-icon.component';
import { JoiInputComponent } from 'src/app/components/joi-input/joi-input.component';
import { Session } from 'src/app/store/programs.era';
import { EditableNotesComponent } from '../program/editable-notes.component';

@Component({
    selector: 'logistics-session-inlay',
    template: `
<ng-container *ngIf="!readOnly && session">
  <title-icon [title]="(type | titlecase) + ' notes'" [titleIcon]="'event_information18'"></title-icon>
  <joi-input [italicPlaceholder]="true" [(model)]="session[notesKey]" [type]="'textarea'" [returnable]="true" [placeholder]="'Click to add ' + type + ' notes...'" (joiChange)="saveSession.emit()"></joi-input>
  <editable-notes
    [initClosed]="true"
    [noPadding]="true"
    [noItemsMessage]="'No ' + type + ' items'"
    [readOnly]="readOnly"
    [notes]="[{ id: '', title: '', items: session[itemsKey] || [], placeholder: ''}]"
    (onChanges)="saveSession.emit()"
  ></editable-notes>
  <title-icon class="margin-top" [title]="'Files'" [titleIcon]="'attachment'"></title-icon>
  <file-handler 
    [data]="{ files: session[filesKey] }" 
    [showNoFilesMessage]="false" 
    (dataChange)="saveFiles($event)">
  </file-handler>
</ng-container>

<ng-container *ngIf="!!readOnly && session">
  <div *ngIf="session[filesKey]?.length">
    <h5>Files</h5>
    <file-handler [readfilesonly]="true" [data]="{ files: session[filesKey] }"></file-handler>
  </div>
  <div *ngIf="session[notesKey]?.length">
    <h5>{{ type | titlecase }} Notes</h5>
    {{session[notesKey] }}
  </div>
  <editable-notes *ngIf="session[itemsKey]?.length"
    [initClosed]="true"
    [noPadding]="true"
    [readOnly]="true"
    [notes]="[{ id: '', title: '', items: session[itemsKey] || [], placeholder: ''}]"
    (onChanges)="saveSession.emit()"
  ></editable-notes>
  <div class="grey-hint" style="font-size: 14px;" *ngIf="!session[filesKey]?.length && !session[notesKey] && !session[itemsKey]?.length">
    No {{ type }} content.
  </div>
</ng-container>
`,
    styles: [`
  file-handler { margin-bottom: 20px; display: block; }  
`],
    standalone: true,
    imports: [FileHandlerComponent, EditableNotesComponent, CommonModule, TitleIconComponent, JoiInputComponent],
})
export class LogisticsSessionInlayComponent {



  @Input() type: 'staging' | 'catering' = 'staging'
  @Input() session?: Session
  
  @Input() notesKey: keyof Session & ('notes' | 'cateringNotes') = 'notes'
  @Input() filesKey: keyof Session & ('files' | 'cateringFiles') = 'files'
  @Input() itemsKey: keyof Session & ('stagingItems' | 'cateringItems') = 'stagingItems'

  @Input() readOnly = false
  @Output() saveSession: EventEmitter<void> = new EventEmitter()
  
  saveFiles(ev) {
    this.session[this.filesKey as any] = ev;
    this.saveSession.emit()
  }

  



}
